import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getUrlParam, isEmpty } from '../../../helpers/common';
import { stripeRedirect } from '../../../services/settingServices';
import { ROUTES } from '../../../routes/urls';
import AppLayout from '../../../component/appLayout';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

function StripePayment() {
  // Mobx store variables
  const { workspaceStore } = rootStore;
  const { currentWorkspace } = workspaceStore;
  const workspace_id = currentWorkspace?.id;
  // Other variables
  const history = useHistory();
  const user_id = getUrlParam(history.location.search, 'user_id');
  const account_id = getUrlParam(history.location.search, 'account_id');
  const install_signature = getUrlParam(history.location.search, 'install_signature');
  const stripe_user_id = getUrlParam(history.location.search, 'stripe_user_id');
  const state = getUrlParam(history.location.search, 'state');
  const liveMode = getUrlParam(history.location.search, 'livemode');

  const loadData = useCallback(async () => {
    if (!isEmpty(workspace_id)) {
      const paramsObj = {
        user_id,
        account_id,
        install_signature,
        stripe_user_id,
        state: isEmpty(state) ? undefined : state,
        livemode: liveMode === 'false' ? false : true
      };
      await stripeRedirect(paramsObj, workspace_id);
      history.push(ROUTES.PAYMENT_SETTING);
    }
  }, [account_id, history, install_signature, liveMode, state, stripe_user_id, user_id, workspace_id]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return <AppLayout>Loading ...</AppLayout>;
}

export default observer(StripePayment);
